/*
 * Copyright (C) 2016 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

// this is the first module loaded by webpack (in the vendor bundle). It tells it
// to load chunks from the CDN url configured in config/canvas_cdn.yml
import webpackPublicPath from '../../../frontend_build/webpackPublicPath'

__webpack_public_path__ = ((window.ENV && window.ENV.ASSET_HOST) || '') + webpackPublicPath
